<template>
  <hs-modal
    :model-value="modelValue"
    :title="title"
    :description="message"
    size="sm"
    @update:modelValue="$emit('update:modelValue', $event)"
    @close="$emit('close')"
  >
    <div class="hs-confirm__icon-wrap">
      <hs-icon :name="resolvedIcon" :tone="tone" soft box-size="4rem" :size="26" />
    </div>
    <template #footer>
      <hs-button variant="secondary" @click="$emit('update:modelValue', false)">{{ cancelText }}</hs-button>
      <hs-button :variant="confirmVariant" :loading="loading" @click="$emit('confirm')">{{ confirmText }}</hs-button>
    </template>
  </hs-modal>
</template>

<script>
import HsButton from "./HsButton.vue";
import HsIcon from "./HsIcon.vue";
import HsModal from "./HsModal.vue";

export default {
  name: "HsConfirmDialog",
  components: { HsButton, HsIcon, HsModal },
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: "Confirm action" },
    message: { type: String, default: "" },
    confirmText: { type: String, default: "Confirm" },
    cancelText: { type: String, default: "Cancel" },
    tone: { type: String, default: "warning" },
    loading: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "confirm", "close"],
  computed: {
    resolvedIcon() {
      return this.tone === "danger" ? "alert-circle" : this.tone === "success" ? "check-circle" : "alert-triangle";
    },
    confirmVariant() {
      return this.tone === "danger" ? "danger" : this.tone === "success" ? "success" : "primary";
    },
  },
};
</script>

<style scoped>
.hs-confirm__icon-wrap {
  display: flex;
  justify-content: center;
  padding: 1rem 0 0.4rem;
}
</style>
